export const THEME_PRESETS = {
    light: import('./palettes/light.module.scss'),
    dark: import('./palettes/dark.module.scss'),
    warm: import('./palettes/warm.module.scss'),
    relax: import('./palettes/relax.module.scss')
};
